module.exports = __webpack_public_path__ + "static/about-1@2x-b2c5cbc5080bafeaba719bacaeafdb69.jpg";